export const WHATSAPP_NUMBER = "8574235891";
export const WHATSAPP_NUMBER_E164 = `91${WHATSAPP_NUMBER}`;
export const WHATSAPP_DISPLAY = "+91 85742 35891";

export function getWhatsAppUrl(message = "") {
  const base = `https://wa.me/${WHATSAPP_NUMBER_E164}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
